export default {"src":"/_next/static/media/fair_trade_logo_.04fcbd80.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};